import { UserInfo } from '@/api/data-contracts';

export const checkPermission = (user: UserInfo | undefined, permission: string) =>
  user?.allPermissions.includes(permission) || user?.extraPermissions.includes(permission) || false;
